export default "__VITE_ASSET__31244518__"